import axios from "axios";
import { exchangeElementsOfTrav } from "../../pages/myExchangeElements/MyExchangeElements";
import { useApi } from "../hooks/useApi"

const api = useApi();

export async function canIcreateTrocAsTrav(): Promise<boolean> {
  try {
    const response = await api.post("trocs-traveler/can-i-do-troc");

    return (response.data.canIcreateTroc ? true : false);
  }
  catch (error) {
    throw error
  }
}

export async function getExchangeElementsTrav(): Promise<exchangeElementsOfTrav[]> {
  try {
    const response = await api.get('trocs-traveler/troc-list-one-traveler');
    return response.data.trocList;
  } catch (error) {
    throw error;
  }
}

export async function getExchangeElementsTravToMakeRequest(): Promise<exchangeElementsOfTrav[]> {
  try {
    const response = await api.get('trocs-traveler/exchange-items-traveler');
    return response.data.trocList;
  } catch (error) {
    throw error;
  }
}

export async function createTrocT(travTroc: {}): Promise<{ canIcreateTroc: boolean }> {
  try {
    const response = await api.post("trocs-traveler/creating", travTroc);
    return response.data;
  }
  catch (error) {

    throw error;
  }
}

export async function editTrocOfTrav(
  trocId: number,
  dataTroc: {
    title: string;
    services: string[];
    needs: string[];
    flexible: boolean;
    start_time: string;
    end_time: string;
    description: string;
  }
): Promise<number> {
  try {
    const { status } = await api.put(`trocs-traveler/editing-troc${trocId}`, dataTroc);

    return status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function removeTrocOfTrav(trocId: number): Promise<number> {
  try {
    const { status } = await api.delete(`trocs-traveler/deleting-troc${trocId}`);
    return status;
  } catch (error) {
    throw error
  }
}

export async function getTravelersTrocsList() {
  try {
    const response = await api.get(`trocs-traveler/troc-list-travelers-all`);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}

export async function likerOrNotTrocTraveler(travTrocId: number) {
  try {
    const response = await api.post(`trocs-traveler/wish-liked-or-not-liked/${travTrocId}`);
    return response.status;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        switch (error.response?.status) {
          case 400:
            throw new Error(`${error.response.data.message}`);
          case 500:
            throw new Error(`${error.response.data.message}`);
          default:
            throw new Error(`Une erreur est survenue.`);
        }
      }
      else if (error.request) {
        throw new Error(`Une erreur est survenue.`);
      }
      else if (axios.isCancel(error)) {
        console.info(`Requête annulée : ${error.message}`);
        throw new Error(`Une erreur est survenue.`);
      }
      else {
        // Ici on cast `error` comme un objet contenant un message
        throw new Error(`Une erreur est survenue.`);
      }
    }
    else {
      // Gère les erreurs non Axios (par exemple, erreur JavaScript générique)
      throw new Error(`Une erreur est survenue.`);
    }
  }
}